import React, { useState } from "react";
import ReactDOM from "react-dom";
import Button from "./form/Button";
import { ReactSVG } from "react-svg";
import cross from "../assets/svgs/cross.svg";
import loadingimage from "../assets/gifs/loading (1).gif";
import SuccessModal from "./SuccessModal";
import ErrorModal from "./ErrorModal";

const SubscribePackageModal = ({
  isOpen,
  onClose,
  onConfirm,
  onSecondaryConfirm,
  packagename,
  packageprice,
  confirmLabel = "Yes",
  secondaryLabel = "No",
  buttonGridClasses = "grid-cols-2",
  buttonsColorOrder = "",
}) => {
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  if (!isOpen) return null;

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const result = await onConfirm();
      // Check if result indicates success
      if (result && result.success) {
        setSuccessMessage(result.message || "Subscribed Successfully");
        setShowSuccess(true);
      } else if (result && result.error) {
        setErrorMessage(result.message || "An error occurred");
        setShowError(true);
      } else {
        // Default success if no specific result returned
        setSuccessMessage("Subscribed Successfully");
        setShowSuccess(true);
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || error?.message || "An error occurred");
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSecondaryConfirm = async () => {
    if (!onSecondaryConfirm) {
      onClose();
      return;
    }

    setLoading(true);
    try {
      await onSecondaryConfirm();
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || error?.message || "An error occurred");
      setShowError(true);
      setLoading(false);
    }
    finally{
      setLoading(false);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    setSuccessMessage("");
    onClose();
  };

  const handleErrorClose = () => {
    setShowError(false);
    setErrorMessage("");
    onClose();
  };

  if (showSuccess) {
    return <SuccessModal close={handleSuccessClose} message={successMessage} button1={"OK"} />;
  }

  if (showError) {
    return <ErrorModal close={handleErrorClose} message={errorMessage} />;
  }

  return ReactDOM.createPortal(
    <div className=" overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 flex justify-center items-center h-full w-full md:inset-0  max-h-full bg-black bg-opacity-50">
      <div className="relative p-7 w-full max-w-md max-h-full">
        <div className="relative px-7 py-6 bg-white rounded-[24px] shadow ">
          {!loading ? (
            <>
              <div className="absolute top-3 right-5">
                <button
                  type="button"
                  className="end-2.5  text-gray-400 cursor-pointer hover:bg-gray-200  rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center  "
                  onClick={onClose}
                >
                  <ReactSVG src={cross} />
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div className="relative mt-5 p-4">
                <p className="font-poppins text-sm font-normal pb-6 text-center text-accent-silver-900 ">
                  Would you like to proceed with the <span className="font-bold">{packagename}</span> package for <span className="font-bold">RM{Number(packageprice).toFixed(2)}</span>?
                </p>
                <div className={`grid ${buttonGridClasses} gap-4 direction-rtl`}>
                  <Button
                    children={secondaryLabel}
                    intent={buttonsColorOrder ? "primary" : "more"}
                    roundness={"pill"}
                    type={"button"}
                    size={"costum"}
                    classes={
                      buttonsColorOrder
                        ? "px-3"
                        : "text-primary border border-primary bg-white px-3"
                    }
                    eventAction={handleSecondaryConfirm}
                  />

                  <Button
                    children={confirmLabel}
                    intent={buttonsColorOrder ? "more" : "primary"}
                    size={"costum"}
                    roundness={"pill"}
                    classes={
                      buttonsColorOrder
                        ? "text-primary border border-primary bg-white px-3"
                        : "px-3"
                    }
                    eventAction={handleConfirm}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="flex flex-col gap-2 items-center justify-center pb-7">
              <img src={loadingimage} alt="loading" className="w-20 h-20" />
              <p className="text-base font-semibold">Processing...</p>
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default SubscribePackageModal;
